import { Form } from "antd";
import { useState } from "react";
import { IntegrationFormData } from "../../../api";
import { IntegrationActions } from "../actions/IntegrationActions";
import { useIntegrationStateContext } from "../context/IntegrationStateContext";
import "./integration-platform.scss";
import { IntegrationPanelForm } from "./IntegrationPanelForm";
import { IntegrationPanelTable } from "./IntegrationPanelTable";
import { VariableDefintionsDrawer } from "./VariableDefintionsDrawer";

interface IntegrationPanelProps {
  consumerId: string;
}

export function IntegrationPanel({ consumerId }: IntegrationPanelProps) {
  const [variablesDrawerCollapsed, setVariablesDrawerCollapsed] =
    useState(true);
  const { activeCell, integrations } = useIntegrationStateContext();

  const [form] = Form.useForm<IntegrationFormData>();

  return (
    <>
      <IntegrationActions
        selectedIntegration={{
          id: activeCell?.data.id || "",
          name: activeCell?.data.name || "",
        }}
        integrations={integrations.value?.items || []}
        form={form}
        consumerId={consumerId}
      />
      <div className="panel-container" data-testid="integration-panel">
        <div className="panel-left">
          <IntegrationPanelTable
            integrationsData={integrations.value?.items || []}
            integrationsLoading={integrations.loading}
          />
        </div>
        <div className="panel-right">
          <IntegrationPanelForm form={form} />
        </div>
        <VariableDefintionsDrawer
          variablesDrawerCollapsed={variablesDrawerCollapsed}
          setVariablesDrawerCollapsed={setVariablesDrawerCollapsed}
          selectedFormat={form.getFieldValue("templateContentType")}
        />
      </div>
    </>
  );
}
